var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-col",
    {
      attrs: {
        cols: "12"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-card-header",
            [
              _vm._v(" Approved Access "),
              _c(
                "gg-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    tile: "",
                    color: "primary"
                  },
                  on: {
                    click: function click($event) {
                      _vm.accessDialog = true
                    }
                  }
                },
                [
                  _vm._v(" Invite "),
                  _c(
                    "span",
                    {
                      staticClass: "visually-hidden text-lowercase"
                    },
                    [_vm._v("button")]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.headersApproved,
                    items: _vm.accessApprovedList,
                    "show-expand": "",
                    expanded: _vm.expandedApproved,
                    "item-key": "id",
                    "single-expand": "",
                    loading: !_vm.loaded
                  },
                  on: {
                    "update:expanded": function updateExpanded($event) {
                      _vm.expandedApproved = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "expanded-item",
                      fn: function fn(_ref) {
                        var headers = _ref.headers,
                          item = _ref.item
                        return [
                          _c(
                            "td",
                            {
                              attrs: {
                                colspan: headers.length
                              }
                            },
                            [
                              _c("v-data-iterator", {
                                attrs: {
                                  items: item.services,
                                  "hide-default-footer": ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function fn(props) {
                                        return [
                                          _c(
                                            "v-row",
                                            _vm._l(props.items, function(
                                              serv,
                                              index
                                            ) {
                                              return _c(
                                                "v-col",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                    md: "3"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            dense: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _vm._v(
                                                                    " Service ID: "
                                                                  ),
                                                                  _c(
                                                                    "router-link",
                                                                    {
                                                                      attrs: {
                                                                        to: _vm.manageServiceLink(
                                                                          serv
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          serv.id
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _vm._v(
                                                                    " Name: "
                                                                  ),
                                                                  _c(
                                                                    "router-link",
                                                                    {
                                                                      attrs: {
                                                                        to: _vm.manageServiceLink(
                                                                          serv
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          serv.name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _vm._v(
                                                                    " Domain: "
                                                                  ),
                                                                  _c(
                                                                    "router-link",
                                                                    {
                                                                      attrs: {
                                                                        to: _vm.manageServiceLink(
                                                                          serv
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          serv.domain
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "gg-btn",
                                                                    {
                                                                      attrs: {
                                                                        text: ""
                                                                      },
                                                                      on: {
                                                                        click: function click(
                                                                          $event
                                                                        ) {
                                                                          return _vm.callDeleteAccessModal(
                                                                            item.id,
                                                                            serv.id
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Delete Access "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "visually-hidden text-lowercase"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "button"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      slot: "progress",
                      color: "green",
                      height: "2",
                      indeterminate: ""
                    },
                    slot: "progress"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("access-invitation-form", {
        attrs: {
          opened: _vm.accessDialog
        },
        on: {
          close: function close($event) {
            _vm.accessDialog = false
          }
        }
      }),
      _c("delete-access-modal", {
        attrs: {
          opened: _vm.deleteAccessModal,
          account: _vm.deleteAccessAccount,
          service: _vm.deleteAccessService
        },
        on: {
          close: _vm.closeDeleteAccessModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }